export default function ESTJ(props) {
  return (
    <div className="row">
      <div className="col-12 p-5">
        <article className="main description">
          <h1>شخصیت “مجری”</h1>{" "}
          <blockquote>
            <p>نظم خوب پایه و اساس همه چیز است.</p>{" "}
            <footer>Edmund Burke</footer>
          </blockquote>{" "}
          <p>
            مجریان نمایندگان سنت و نظم هستند و از درک خود در مورد امور درست،
            نادرست و قابل قبول اجتماع برای گردهم آوردن خانواده&zwnj;ها و جوامع
            استفاده می&zwnj;کنند. افراد دارای گونه شخصیتی مجری از ارزش&zwnj;های
            صداقت، فداکاری و کرامت استقبال می&zwnj;کنند و دیگران به&zwnj;خاطر
            مشاوره&zwnj;ها و راهنمایی&zwnj;های روشن آنها برایشان ارزش قائل
            هستند، و از اینکه در مسیرهای دشوار پیشرو باشند خرسندند. مجریان که از
            گردهم آوردن افراد در کنار هم احساس غرور می&zwnj;کنند، اغلب نقش
            سازمان&zwnj;دهندگان اجتماعی را ایفا می&zwnj;کنند و با سختکوشی همه
            افراد را برای شرکت در جشن رویدادهای محلی، یا در دفاع از
            ارزش&zwnj;های سنتی که خانواده&zwnj;ها و جوامع را در کنار هم نگه
            می&zwnj;دارد، گردهم می&zwnj;آورند.
          </p>{" "}
          <h2>
            هر کسی که ارزشش را دارد باید در دفاع از آنچه که به باورش صحیح است به
            پا خیزد ...
          </h2>{" "}
          <p>
            تقاضا برای این نوع رهبری در جوامع دموکراتیک بالا است و حدود 11%
            جمعیت را تشکیل می&zwnj;دهد، جای تعجب نیست که بسیاری از رهبران معروف
            سیاسی و کسب و کار در سراسر جهان از جمله مجریان بوده&zwnj;اند.
            شخصیت&zwnj;های مجری افرادی هستند که عمیقاً به حکومت قانون و مشروعیتی
            که باید کسب شود معتقد هستند، آنها سرمشق دیگران هستند و تعهد و صداقت
            هدفمندی را از خود نشان داده و تنبلی و تقلب را به&zwnj;خصوص در مورد
            کار مطلقاً رد می&zwnj;کنند. اگر کسی اعلام کند که کار سخت و جسمی راهی
            عالی برای ساختن شخصیت است، گونه شخصیتی مجری دارد.
          </p>{" "}
          <p>
            مجریان از محیط اطراف خود آگاه هستند و در جهانی با حقایق روشن و قابل
            اثبات زندگی می&zwnj;کنند - دانش آنها بدان معنی است که حتی در برابر
            مقاومت سنگین، به اصول خود وفادار می&zwnj;مانند و به&zwnj;روشنی اعلام
            می&zwnj;کنند که چه چیزی قابل قبول است و چه چیزی قابل قبول نیست.
            نظرات آنها فقط یک مشت حرف پوچ نیست، زیرا شخصیت&zwnj;های مجری
            به&zwnj;راستی تمایل دارند به سراغ چالش&zwnj;برانگیزترین
            پروژه&zwnj;ها بروند و در طی مسیر برنامه&zwnj;های اجرایی را بهبود
            ببخشند و جزئیات را مشخص سازند، و باعث شوند حتی پیچیده&zwnj;ترین
            وظایف نیز آسان و قابل دستیابی به نظر برسد.
          </p>{" "}
          <p>
            با این حال، مجریان به تنهایی کار نمی&zwnj;کنند، و انتظار دارند
            قابلیت اعتماد و اعتقادشان به اخلاق کاری متقابل باشد - افراد دارای
            این گونه شخصیتی به وعده&zwnj;های خود عمل می&zwnj;کنند و اگر شرکا یا
            زیردستان آنها با بی&zwnj;کفایتی یا تنبلی یا حتی بدتر با
            بی&zwnj;صداقتی وضعیت&zwnj;شان را به خطر بیندازند از نشان دادن خشم
            خود دریغ نمی&zwnj;کنند. این مسئله می&zwnj;تواند به شهرت مجریان در
            عدم انعطاف بینجامد، اما دلیلش این نیست که آنها خودسر هستند، بلکه به
            این دلیل است که واقعاً بر این باورند که این ارزش&zwnj;ها باعث
            می&zwnj;شوند جامعه کارآمد باشد.
          </p>{" "}
          <h2>
            ... اما از آنها هم بهتر کسانی هستند که وقتی خطایی می&zwnj;کنند به آن
            اقرار دارند
          </h2>{" "}
          <blockquote className="no-footer">
            <p>
              مجریان تصویری کلاسیک از شهروندان سرمشق هستند: آن&zwnj;ها به
              همسایگان خود کمک می&zwnj;کند، به قانون وفادار هستند و سعی
              می&zwnj;کنند مطمئن شوند همه در جوامع و سازمان&zwnj;هایی که تا آن
              اندازه برایشان عزیز است مشارکت می&zwnj;کنند.
            </p>
          </blockquote>{" "}
          <p>
            چالش اصلی پیش روی افراد دارای این گونه شخصیتی مجری این است که بدانند
            همه افراد از یک مسیر پیروی نمی&zwnj;کنند یا به شیوه&zwnj;ای مشابه
            یاری نمی&zwnj;رسانند. یک رهبر واقعی قدرت افراد، و همچنین گروه را به
            رسمیت می&zwnj;شناسد، و کمک می&zwnj;کند تا نظرات آن افراد مطرح گردد.
            به این ترتیب، شخصیت&zwnj;های مجری به&zwnj;راستی تمام واقعیت&zwnj;ها
            را در اختیار دارند، و قادر هستند کارها را به شیوه&zwnj;ای پیش ببرند
            که برای همه مفید باشد.
          </p>
        </article>
      </div>
    </div>
  );
}
